const faqs = [
  {
    question: "What is a Hackathon?",
    answer:
      "A hackathon is social coding event where programmers, designers, and developers collaborate to solve a problem and compete for cash prizes. It’s one part party, one part work-hard overnight battle against the clock and the competition.",
  },
  {
    question: "Why should I participate?",
    answer:
      "People participate in hackathons for lots of reason: the challenge, the creative outlet, the community collaboration, the networking, the swag and maybe Prizes!",
  },
  {
    question: "What if I don't have a team or idea?",
    answer:
      "We'll have team formation and ideation events geared towards helping you find a team. Make sure you join the discord server.",
  },
  {
    question: "Who can participate?",
    answer:
      "Everyone is welcome to apply, any student or working professionals. If you can innovate or just want to have a fun weekend, you are most welcome.",
  },
  {
    question: "What are the prerequisites for participating?",
    answer:
      "Anyone is welcome to participate in this event. While experience coding and programming is a huge plus, teams will also need strong presentation skills and brilliant ideas.",
  },
  {
    question: "I don't have a team, what to do?",
    answer:
      "While you can work alone, Hack4Bengal is a team event, so working with others is encouraged. There are a few ways to find teammates: You can pick your team from people you already know, post in our Discord Server to other members, find a team member via DevPost, meet them at pre-hackathon info sessions or the kickoff party.",
  },
  {
    question: "How can I prepare myself?",
    answer:
      "Other than finding fellow brilliant minds with complementary skills to team up with, there is nothing that you need to prepare in advance.",
  },
  {
    question: "Is there any fees involved?",
    answer:
      "It's free for everyone to participate. There is no money involved at any point during this Hackathon.",
  },
];

export default faqs;
